
export const SELECTION_CHANGED = 'SELECTION_CHANGED'

export const selectionChanged = (selection) => ({
  type      : SELECTION_CHANGED,
  selection : selection
})

export const CLOUD_SELECTION_CHANGED = 'CLOUD_SELECTION_CHANGED'

export const cloud_selection_changed = cloud_selection => ({
  type            : CLOUD_SELECTION_CHANGED,
  cloud_selection : cloud_selection
})
